<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_iii"></a>Nazi Spies and Collaborators in Britain, 1939–1945</h1>
<p class="author">Neil R. Storey</p>
<div class="image_containerf">
<img alt="Image" src="images/fiii-01.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?28c22056